import React from 'react';

export const ArrowIncomingIcon = ({ fill='none', width='20', height='20', className='' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M6.50543 13.1486L14.4516 5.21014C14.5624 5.09937 14.6816 5.04859 14.8093 5.05782C14.937 5.06706 15.0562 5.12706 15.167 5.23782C15.2777 5.34859 15.3331 5.46987 15.3331 5.60166C15.3331 5.73345 15.2777 5.85473 15.167 5.9655L7.24849 13.8917L14.1454 13.8917C14.2928 13.8917 14.4163 13.9411 14.5159 14.04C14.6156 14.1389 14.6654 14.2615 14.6654 14.4077C14.6654 14.5539 14.6156 14.6778 14.5159 14.7793C14.4163 14.8809 14.2928 14.9316 14.1454 14.9316L6.10853 14.9316C5.92633 14.9316 5.7736 14.87 5.65035 14.7468C5.5271 14.6235 5.46547 14.4708 5.46547 14.2886L5.46547 6.25166C5.46547 6.10433 5.51492 5.98083 5.61383 5.88118C5.71274 5.78151 5.8353 5.73168 5.98151 5.73168C6.12772 5.73168 6.2516 5.78151 6.35313 5.88118C6.45466 5.98083 6.50543 6.10433 6.50543 6.25166L6.50543 13.1486Z" 
fill={fill}/>
</svg>


    );
};

export default ArrowIncomingIcon;
